import api from "../../../api/axios";

const getServerLicenseHistory = async (serverUuid, licenseId) => {
  try {
    const response = await api.get(
      `/api/servers/${serverUuid}/licenses/${licenseId}/audit`
    );

    return response.data;
  } catch (error) {
    console.error("getServerLicenseHistory", error);
    return undefined;
  }
};

const getSiteLicenseHistory = async (serverUuid, siteId, licenseId) => {
  try {
    const response = await api.get(
      `/api/servers/${serverUuid}/sites/${siteId}/licenses/${licenseId}/audit`
    );

    return response.data;
  } catch (error) {
    console.error("getServerLicenseHistory", error);
    return undefined;
  }
};

export default {
  getServerLicenseHistory,
  getSiteLicenseHistory,
};
